import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Checkbox, Text } from '@fhs/ui';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { CHECKOUT_DELIVERY_SAVE_ADDRESS_CHECKBOX } from '@fhs-legacy/frontend/src/utils/test-ids';

export default function SaveAddressCheckbox() {
  const { deliveryAddress, updateShouldSaveDeliveryAddress } = useOrderContext();

  const handleSaveAddressChange = checked => {
    updateShouldSaveDeliveryAddress(checked);
  };

  return (
    <View testID={CHECKOUT_DELIVERY_SAVE_ADDRESS_CHECKBOX}>
      <Checkbox
        checked={deliveryAddress?.shouldSave || false}
        onChange={handleSaveAddressChange}
        label="Save My Information. Please save my phone number and delivery address for faster checkout the next time I place an order."
      >
        <View style={styles.checkboxContentContainer}>
          <Checkbox.Control />
          <Text.Ui size="lg">Save my address for future orders</Text.Ui>
        </View>
      </Checkbox>
    </View>
  );
}

const styles = StyleSheet.create({
  checkboxContentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flex: 1,
    position: 'relative',
    paddingBottom: 16,
  },
  phoneToggleContainer: {
    position: 'relative',
    flex: 1,
    paddingHorizontal: 2,
  },
  flexRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: 8,
  },
  saveAddressToggleText: {
    flex: 1,
    marginRight: 8,
  },
  dropdownPane: {
    left: 16,
    right: 16,
    // override default because it cuts off right side
    transform: 'none',
  },
  addressDropdownContent: {
    padding: 12,
    borderRadius: 8,
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
    elevation: 3,
  },
});
